import { VariantItemPdp } from "@/common/lib/types";

interface VolumeSeelctedProps {
    label: string;
    selectedSize: string;
    handleSizeChange: (fitKey: string) => void;
    selectedVariant: VariantItemPdp;
    variants: Record<string, VariantItemPdp[]>;
}

const VolumeSelector = ({ label, selectedSize, selectedVariant, handleSizeChange, variants }: VolumeSeelctedProps) => {
    return (
        <div>
            <h2 className="font-semibold">{label ?? "Volume"}: </h2>
            <form className="flex flex-wrap items-center gap-4 py-2">
                {Object.keys(variants)?.map((variant, idx) => {
                    const isOutOfStock = selectedSize == variant ? selectedVariant?.quantityAvailable < 1 : variants[variant]?.[0]?.quantityAvailable < 1;
                    return (
                        <span key={idx} className="flex items-center gap-2">
                            <input
                                type="radio"
                                alt="pack_size"
                                id={`pack${idx}`}
                                name="packSize"
                                value={variant}
                                className="focus:outline-none focus:ring-0 focus:ring-white"
                                onChange={() => handleSizeChange(variant)}
                                defaultChecked={selectedSize == variant}
                            />
                            <label htmlFor={`pack${idx}`} className="cursor-pointer text-sm" style={isOutOfStock ? { opacity: "0.5" } : {}}>
                                {variant}
                            </label>
                        </span>
                    );
                })}
            </form>
        </div>
    );
};

export default VolumeSelector;
